// extracted by mini-css-extract-plugin
export default {"spacer":"rG8DLtQaXvWS6aCelVQP","question":"v2WkTt4jenSnOwp8NDi3","placeholder":"bXLyUWFUEZoT8JUcaVUf"};